import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (localStorage.getItem("cookie_consent") === "accepted") {
      this.element.remove()
    }
  }

  accept() {
    localStorage.setItem("cookie_consent", "accepted")
    this.element.remove()
  }
}
